export default __webpack_public_path__ + "/dist/images/privacy-active.7a950b60c4da4815a694a8a99fb32708.svg";